import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from 'gast-portal-ng';
import { HttpService } from 'gast-common-ng';
import { RouteViewKeys } from '../constants/route-view-keys';
import { UrlService } from './common/url.service';
var BookingStepService = /** @class */ (function () {
    function BookingStepService(router, authService, httpService, urlService) {
        this.router = router;
        this.authService = authService;
        this.httpService = httpService;
        this.urlService = urlService;
        this.steps = new BehaviorSubject([]);
        this.viewStep = new BehaviorSubject([]);
        this.config = new Subject();
        this.needValidation = false;
        this.viewStepLoaded = new EventEmitter();
        this.viewStepWithCodeLoaded = new EventEmitter();
        this.configLoaded = new EventEmitter();
        this.datafileLoaded = new EventEmitter();
    }
    /** get steps as observable */
    BookingStepService.prototype.getSteps = function () {
        return this.steps.asObservable();
    };
    /** get steps as observable */
    BookingStepService.prototype.getViewSteps = function () {
        return this.viewStep.asObservable();
    };
    /** get steps as observable */
    BookingStepService.prototype.getConfig = function () {
        return this.config.asObservable();
    };
    /** get the index of the step */
    BookingStepService.prototype.getCurrentStepIndex = function (currentView, viewSteps, steps) {
        var viewStep = viewSteps.find(function (x) { return x.viewName === currentView; });
        if (viewStep) {
            return steps.indexOf(viewStep.stepName);
        }
        else {
            return 0;
        }
    };
    BookingStepService.prototype.getStartView = function () {
        var stepArray = this.viewStep.getValue();
        if (stepArray.length > 0) {
            var start = stepArray[0];
            return start.viewName;
        }
    };
    /**
     * Go to start
     * 1. startView is empty string navigate to it, it will be redirected to course
     * 2. startView is login check if user logged in redirect to to next view after login
     * 3. step is not initialize redirect to course
     * NOTE: queryParamsHandling per default is merge
     */
    BookingStepService.prototype.goToStart = function (queryParamHandlingOptional) {
        var queryParamHandlingOption = 'merge';
        if (queryParamHandlingOptional) {
            queryParamHandlingOption = queryParamHandlingOptional;
        }
        var queryParamOption = queryParamHandlingOption;
        var stepArray = this.viewStep.getValue();
        if (stepArray.length > 0) {
            var start = stepArray[0];
            if (start.viewName === '') {
                this.router.navigate([start.viewName], { queryParamsHandling: queryParamOption });
            }
            else if (start.viewName === RouteViewKeys.LOGIN && this.isUserLoggedIn()) {
                var nextAfterLogin = stepArray[1];
                this.router.navigate(['course/' + nextAfterLogin.viewName], { queryParamsHandling: queryParamOption });
            }
            else {
                this.router.navigate(['course/' + start.viewName], { queryParamsHandling: queryParamOption });
            }
        }
        else {
            this.router.navigate(['course'], { queryParamsHandling: queryParamOption });
        }
    };
    BookingStepService.prototype.goToShoppingCart = function () {
        this.router.navigate(['course/' + RouteViewKeys.SHOPPING_CART], { queryParamsHandling: 'merge' });
    };
    BookingStepService.prototype.goToSummary = function () {
        this.router.navigate(['course/' + RouteViewKeys.SUMMARY], { queryParamsHandling: 'merge' });
    };
    BookingStepService.prototype.goToCourseClassification = function () {
        this.router.navigate(['course/' + RouteViewKeys.CLASSIFICATION], { queryParamsHandling: 'merge' });
    };
    BookingStepService.prototype.goToBookingConfirmation = function () {
        this.router.navigate(['course/' + RouteViewKeys.CONFIRMATION], { queryParamsHandling: 'merge' });
    };
    BookingStepService.prototype.goToVerification = function () {
        this.router.navigate(['course/' + RouteViewKeys.VERIFICATION], { queryParamsHandling: 'merge' });
    };
    /** go to next step */
    BookingStepService.prototype.goToNextStep = function (currentView, queryParams) {
        var routeConfig = this.viewStep.getValue();
        var currentIndex = routeConfig.findIndex(function (v) { return v.viewName === currentView; });
        if (currentView === 'course-detail') {
            currentIndex = 0;
        }
        var nextView = routeConfig[currentIndex + 1].viewName;
        if (nextView === RouteViewKeys.LOGIN && this.isUserLoggedIn()) {
            var nextViewAfterLogin = routeConfig[currentIndex + 2].viewName;
            this.router.navigate(['course/' + nextViewAfterLogin], { queryParams: queryParams, queryParamsHandling: 'merge' });
        }
        else {
            this.router.navigate(['course/' + nextView], { queryParams: queryParams, queryParamsHandling: 'merge' });
        }
    };
    BookingStepService.prototype.loadDefaultSteps = function () {
        var _this = this;
        this.httpService.get({
            mapper: function (response) { return response.json(); },
            callback: function (result) {
                _this.steps.next(result);
                _this.loadDefaultViewSteps();
            },
            url: this.urlService.getWebshopStepUrl()
        });
    };
    BookingStepService.prototype.loadWebshopConfig = function (code) {
        var _this = this;
        this.httpService.get({
            mapper: function (response) { return response.json(); },
            callback: function (result) {
                _this.configLoaded.emit(result);
            },
            url: this.urlService.getWebshopConfigUrl() + ("/" + code)
        });
    };
    BookingStepService.prototype.loadStepsByCode = function (code) {
        var _this = this;
        this.httpService.get({
            mapper: function (response) { return response.json(); },
            callback: function (result) {
                _this.steps.next(result);
                _this.loadViewStepsByCode(code);
            },
            url: this.urlService.getWebshopStepUrl() + ("/" + code)
        });
    };
    BookingStepService.prototype.loadDefaultViewSteps = function () {
        var _this = this;
        this.httpService.get({
            mapper: function (response) { return response.json(); },
            callback: function (result) {
                _this.viewStep.next(result);
                _this.viewStepLoaded.emit();
            },
            url: this.urlService.getWebshopViewStepUrl()
        });
    };
    BookingStepService.prototype.loadViewStepsByCode = function (code) {
        var _this = this;
        this.httpService.get({
            mapper: function (response) { return response.json(); },
            callback: function (result) {
                _this.viewStep.next(result);
                _this.viewStepWithCodeLoaded.emit();
            },
            url: this.urlService.getWebshopViewStepUrl() + ("/" + code)
        });
    };
    BookingStepService.prototype.loadWebshopDatafileByWebshopConfig = function (webshopConfigId) {
        var _this = this;
        this.httpService.get({
            mapper: function (response) { return response.json(); },
            callback: function (result) {
                _this.datafileLoaded.emit(result);
            },
            url: this.urlService.getWebshopDatafileUrl() + ("/" + webshopConfigId)
        });
    };
    /** check if current user is logged in */
    BookingStepService.prototype.isUserLoggedIn = function () {
        var userInfo = this.authService.readUserInfo();
        if (userInfo && userInfo.username) {
            return true;
        }
        return false;
    };
    BookingStepService.prototype.setNeedValidation = function () {
        this.needValidation = true;
    };
    BookingStepService.prototype.getNeedValidation = function () {
        return this.needValidation;
    };
    return BookingStepService;
}());
export { BookingStepService };
